export class SentryEmptyError extends Error {
    constructor() {
        super(':shrug:');
        this.name = 'EmptyError';
    }
}

export class SentrySimpleDataError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'SimpleDataError';
    }
}

export class SentryComplexDataError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'ComplexDataError';
    }
}

export class SentryUnknownError extends Error {
    constructor(message = ':shrug:') {
        super(message);
        this.name = 'UnknownError';
    }
}
